import React, { useState } from 'react'
import { Badge, IconButton } from '@material-ui/core'
import { MessageSquare } from 'react-feather'
import { useReactiveVar } from '@apollo/client'
import { CommentsDialog, commentIsInLocation } from './CommentsDialog'
import { projectVar } from '../../apollo/reactive-vars'
import { CommentLocationType } from '../../generated/graphql'

type Props = {
  locationType: CommentLocationType
}

export function CommentsButton({ locationType }: Props): React.ReactElement {
  const [isCommentsDialogOpen, setIsCommentsDialogOpen] = useState(false)
  const project = useReactiveVar(projectVar)
  if (!project) {
    return <></>
  }

  const hasComments =
    project.comments.some(commentIsInLocation(locationType)) ||
    project.versions.some((version) =>
      version.comments.some(commentIsInLocation(locationType)),
    )

  return (
    <>
      <IconButton
        id="open-comments-button"
        onClick={() => setIsCommentsDialogOpen(true)}
      >
        <Badge
          overlap="rectangular"
          badgeContent={hasComments ? '!' : '+'}
          color={hasComments ? 'primary' : 'default'}
        >
          <MessageSquare />
        </Badge>
      </IconButton>

      <CommentsDialog
        project={project}
        locationType={locationType}
        isOpen={isCommentsDialogOpen}
        onClose={() => setIsCommentsDialogOpen(false)}
      />
    </>
  )
}
